import Vue from 'vue'
import Router from 'vue-router'
import RoomList from './views/RoomList.vue'
import RatingForm from './views/RatingForm.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/rooms'
    },
    { 
      path: '*',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/rooms',
      name: 'RoomList',
      component: RoomList,
    },
    
    {
      path: '/rating/:bookingHash',
      name: 'RatingForm',
      component: RatingForm,
    },
    {
      path: '/ratings/:seminarDateHash',
      name: 'RatingsForm',
      component: RatingForm,
    },
    {
      path: '/form.html',
      beforeEnter: (to, from, next) => {
        if (to.query.h && to.query.type && to.query.type === 'trainer') {
          next({ name: 'RatingsForm', params: { seminarDateHash: to.query.h, link: to.fullPath } });
        } else if(to.query.h) {
          next({ name: 'RatingForm', params: { bookingHash: to.query.h, link: to.fullPath }});
        } else {
          next();
        }
      }
    }
    //@todo: legacy routes
    // {
    //   path: '/form.html?h=:bookingHash',
    //   name: 'RatingForm',
    //   component: RatingForm,
    // }
  ]
})

export default router;
